import React, { useState, setState } from 'react'
import './BHomepage.css'
import BCard from './BHomeCard.js'
import influencers from '../sampleJSON/trending.json'
import logo from '../images/logo.png'
import { useNavigate } from "react-router-dom";
import NavbarBrand from './NavbarBrand'
import {Pagination,Navigation} from 'swiper';
import SwiperCore, { Keyboard, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss'; // core Swiper
import 'swiper/modules/navigation/navigation.scss'; // Navigation module
import 'swiper/modules/pagination/pagination.scss'; // Pagination module
import Navbar from './navBar'
SwiperCore.use([Keyboard, Mousewheel]);
export default function BHomepage() {
    let navigate = useNavigate(); 
    let influarray = influencers.influencers;
    const [query, setQuery] = useState("");
    function handleInputChange(e) {
        setQuery(e.target.value)
    }
    function ClickLogo(){
        let path = `/`; 
        navigate(path);
    }
    return (
        <>
           
            <div className='b1-upper'>
                <img src={logo} alt='logo' className='b1-logo' onClick={ClickLogo}></img>
                <button className='logout1'>Logout</button>
                {/* <img src='/images/alert.png' alt='alert' className='b1-alert'></img> */}
                <div className='b1-searchbar'>
                    <img src='../images/search.svg' alt='' className='b1-searchicon'></img>
                    <input type='text' className='b1-search' value={query} placeholder='Search influencers...' onChange={(e) => handleInputChange(e)} />
                </div>
            </div>
            {/* <div className="b1-vertMenu">
            <a href="/" className='H-txt'> <img src='/images/home.png' className="b1-icon1" alt='home'></img></a>
            <a href="/bhomepage" className='H-txt'><img src='/images/search-coloured.png' className="b1-icon2" alt='search'></img></a>
            <a href="/chat" className='H-txt'> <img src='/images/message.png' className="b1-icon3" alt='message'></img></a>
            <a href="/brand-details" className='H-txt'> <img src='/images/profile-coloured.png' className="b1-icon4" alt='person'></img></a> 
            </div> */}
            <Navbar />
            <div className='b1-trending'>
                <div className='b1-trending2'>
                    <span className='b1-p1'>Trending</span>
                    {/* <img className='b1-arrow swiper-pagination' src='/images/right-arrow.png' alt='click'></img> */}
                </div>
                <Swiper
                    modules={[Mousewheel,Keyboard,Pagination,Navigation]}
                    spaceBetween={10}
                    slidesPerView={6}
                    pagination={{ clickable: true }}
                    Mousewheel={{eventTarget:'.b1-trending'}}
                    Keyboard
                    direction='horizontal'
                    Navigation={true}
                    className='b1-tr3'
                    breakpoints={{
                        300: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                        650: {
                          slidesPerView: 3,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 6,
                          spaceBetween: 20,
                        },
                    }}>
                    {
                        influarray.map((element) => {
                            return <div className="b1-card" key={element.id}>
                                <SwiperSlide>
                                <BCard rating={element.rating} followers={element.followers} platform={element.platform} />
                                </SwiperSlide>
                            </div>
                        })
                    }
                </Swiper>
            </div>
            <div className='b1-top-performing'>
                <div className='b1-top-performing2'>
                    <span className='b1-p2'>Top performing</span>
                    {/* <img className='b1-arrow2' src='/images/right-arrow.png' alt='click'></img> */}
                </div>
                <Swiper
                    modules={[Mousewheel,Keyboard,Pagination]}
                    spaceBetween={10}
                    slidesPerView={6}
                    pagination={{ clickable: true }}
                    Mousewheel={true}
                    Keyboard={true}
                    className='b1-tp3'
                    breakpoints={{
                        300: {
                          slidesPerView: 2,
                          spaceBetween: 20,
                        },
                        650: {
                          slidesPerView: 3,
                          spaceBetween: 40,
                        },
                        1024: {
                          slidesPerView: 6,
                          spaceBetween: 20,
                        },
                    }}>
                    {
                        influarray.map((element) => {
                            return <div className="b1-card" key={element.id}>
                                <SwiperSlide>
                                <BCard rating={element.rating} followers={element.followers} platform={element.platform} />
                                </SwiperSlide>
                            </div>
                        })
                    }
                </Swiper>
            </div>
        </>
    )
}